(function($){
var $ = jQuery = $;

theme.icons = {
  left: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
  right: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
  close: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
  chevronLightLeft: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg>',
  chevronLightRight: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg>',
  chevronLeft: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/><path d="M0-.5h24v24H0z" fill="none"/></svg>',
  chevronRight: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/></svg>',
  chevronDown: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
  tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>',
  add: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
  rarr: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m 18.49769,10.0784 -6.8e-5,1.626923 -15.4346662,0 0,0.64 15.4346662,0 0,1.594277 2.174734,-1.930277 z" /><path d="M0-.25h24v24H0z" fill="none" /></svg>'
};

theme.Sections = new function(){
  var _ = this;

  _._instances = [];
  _._sections = [];

  _.init = function(){
    $(document).on('shopify:section:load', function(e){
      // load a new section
      var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
      if(target) {
        _.sectionLoad(target);
      }
    }).on('shopify:section:unload', function(e){
      // unload existing section
      var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
      if(target) {
        _.sectionUnload(target);
      }
    });
  }

  // register a type of section
  _.register = function(type, section){
    _._sections.push({ type: type, section: section });
    $('[data-section-type="'+type+'"]').each(function(){
      _.sectionLoad(this);
    });
  }

  // load in a section
  _.sectionLoad = function(target){
    var target = target;
    var section = _._sectionForTarget(target);
    if(section !== false) {
      _._instances.push({
        target: target,
        section: section
      });
      section.onSectionLoad(target);
      $(target).on('shopify:block:select', function(e){
        _._callWith(section, 'onBlockSelect', e.target);
      }).on('shopify:block:deselect', function(e){
        _._callWith(section, 'onBlockDeselect', e.target);
      });
    }
  }

  // unload a section
  _.sectionUnload = function(target){
    var instanceIndex = -1;
    for(var i=0; i<_._instances.length; i++) {
      if(_._instances[i].target == target) {
        instanceIndex = i;
      }
    }
    if(instanceIndex > -1) {
      $(target).off('shopify:block:select shopify:block:deselect');
      _._callWith(_._instances[instanceIndex].section, 'onSectionUnload', target);
      _._instances.splice(instanceIndex);
    }
  }

  // helpers
  _._callWith = function(object, method, param) {
    if(typeof object[method] === 'function') {
      object[method](param);
    }
  }

  _._themeSectionTargetFromShopifySectionTarget = function(target){
    var $target = $('[data-section-type]:first', target);
    if($target.length > 0) {
      return $target[0];
    } else {
      return false;
    }
  }

  _._sectionForTarget = function(target) {
    var type = $(target).attr('data-section-type');
    for(var i=0; i<_._sections.length; i++) {
      if(_._sections[i].type == type) {
        return _._sections[i].section;
      }
    }
    return false;
  }
}

// Loading third party scripts
theme.scriptsLoaded = [];
theme.loadScriptOnce = function(src, callback, beforeRun) {
  if(theme.scriptsLoaded.indexOf(src) < 0) {
    theme.scriptsLoaded.push(src);
    var tag = document.createElement('script');
    tag.src = src;

    if(beforeRun) {
      tag.async = false;
      beforeRun();
    }

    if(typeof callback == 'function') {
      if (tag.readyState) { // IE, incl. IE9
        tag.onreadystatechange = function() {
          if (tag.readyState == "loaded" || tag.readyState == "complete") {
            tag.onreadystatechange = null;
            callback();
          }
        };
      } else {
        tag.onload = function() { // Other browsers
          callback();
        };
      }
    }

    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    return true;
  } else {
    if(typeof callback == 'function') {
      callback();
    }
    return false;
  }
}

// Manage videos
theme.VideoManager = new function(){
  var _ = this;

  // Youtube
  _.youtubeVars = {
    incrementor: 0,
    apiReady: false,
    videoData: {},
    toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)'
  };

  _.youtubeApiReady = function() {
    _.youtubeVars.apiReady = true;
    _._loadYoutubeVideos();
  }

  _._loadYoutubeVideos = function(container) {
    if($(_.youtubeVars.toProcessSelector, container).length) {
      if(_.youtubeVars.apiReady) {
        // play those videos
        $(_.youtubeVars.toProcessSelector, container).addClass('video--init').each(function(){
          _.youtubeVars.incrementor++;
          var containerId = 'theme-yt-video-'+_.youtubeVars.incrementor;
          var videoElement = $('<div>').attr('id', containerId).appendTo(this);
          var player = new YT.Player(containerId, {
            height: '390',
            width: '640',
            videoId: $(this).data('video-id'),
            playerVars: {
              iv_load_policy: 3,
              modestbranding: 1,
              autoplay: !!$(this).data('video-autoplay') ? 1 : 0,
              rel: 0
            },
            events: {
              onReady: _._onYoutubePlayerReady,
              onStateChange: _._onYoutubePlayerStateChange
            }
          });
          _.youtubeVars.videoData[player.h.id] = {
            id: containerId,
            container: this,
            videoElement: videoElement,
            player: player
          };
        });
      } else {
        // load api
        theme.loadScriptOnce('https://www.youtube.com/iframe_api');
      }
    }
  }

  _._onYoutubePlayerReady = function(event) {
    event.target.setPlaybackQuality('hd1080');
  }

  _._onYoutubePlayerStateChange = function(event) {
  }

  _._getYoutubeVideoData = function(event) {
    return _.youtubeVars.videoData[event.target.h.id];
  }

  _._unloadYoutubeVideos = function(container) {
    for(var dataKey in _.youtubeVars.videoData) {
      var data = _.youtubeVars.videoData[dataKey];
      if($(container).find(data.container).length) {
        data.player.destroy();
        delete _.youtubeVars.videoData[dataKey];
        return;
      }
    }
  }

  // Vimeo
  _.vimeoVars = {
    incrementor: 0,
    apiReady: false,
    videoData: {},
    toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)'
  };

  _.vimeoApiReady = function() {
    _.vimeoVars.apiReady = true;
    _._loadVimeoVideos();
  }

  _._loadVimeoVideos = function(container) {
    if($(_.vimeoVars.toProcessSelector, container).length) {
      if(_.vimeoVars.apiReady) {
        // play those videos
        $(_.vimeoVars.toProcessSelector, container).addClass('video--init').each(function(){
          _.vimeoVars.incrementor++;
          var $this = $(this);
          var containerId = 'theme-vi-video-'+_.vimeoVars.incrementor;
          var videoElement = $('<div>').attr('id', containerId).appendTo(this);
          var autoplay = !!$(this).data('video-autoplay');
          var player = new Vimeo.Player(containerId, {
            id: $(this).data('video-id'),
            width: 640,
            loop: false,
            autoplay: autoplay
          });
          player.ready().then(function(){
            if(player.element && player.element.width && player.element.height) {
              var ratio = parseInt(player.element.height) / parseInt(player.element.width);
              $this.css('padding-bottom', (ratio*100) + '%');
            }
          });
          _.vimeoVars.videoData[containerId] = {
            id: containerId,
            container: this,
            videoElement: videoElement,
            player: player,
            autoPlay: autoplay
          };
        });
      } else {
        // load api
        if(window.define) {
          // workaround for third parties using RequireJS
          theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function(){
            _.vimeoVars.apiReady = true;
            _._loadVimeoVideos();
            window.define = window.tempDefine;
          }, function(){
            window.tempDefine = window.define;
            window.define = null;
          });
        } else {
          theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function(){
            _.vimeoVars.apiReady = true;
            _._loadVimeoVideos();
          });
        }
      }
    }
  }

  _._unloadVimeoVideos = function(container) {
    for(var dataKey in _.vimeoVars.videoData) {
      var data = _.vimeoVars.videoData[dataKey];
      if($(container).find(data.container).length) {
        data.player.unload();
        delete _.vimeoVars.videoData[dataKey];
        return;
      }
    }
  }

  // Compatibility with Sections
  this.onSectionLoad = function(container){
    _._loadYoutubeVideos(container);
    _._loadVimeoVideos(container);

    theme.checkViewportFillers();
    theme.assessAltLogo();

    // play button
    $('.video-container__play', container).on('click', function(){
      // reveal
      var $cover = $(this).closest('.video-container__cover').addClass('video-container__cover--playing');
      // play
      var id = $cover.next().attr('id');
      if(id.indexOf('theme-yt-video') === 0) {
        _.youtubeVars.videoData[id].player.playVideo();
      } else {
        _.vimeoVars.videoData[id].player.play();
      }
    });
  }

  this.onSectionUnload = function(container){
    $('.video-container__play', container).off('click');
    _._unloadYoutubeVideos(container);
    _._unloadVimeoVideos(container);
  }
}

// Youtube API callback
window.onYouTubeIframeAPIReady = function() {
  theme.VideoManager.youtubeApiReady();
}

theme.HeaderSection = new function(){
  this.onSectionLoad = function(target){
    theme.addControlPaddingToModal();
    theme.assessAltLogo();
    $('body').toggleClass('modal-active', $('.theme-modal.reveal').length > 0);
    $('#faux-site-control a', target).attr('tabindex', '-1');
    $('#page-menu a', target).attr('tabindex', '-1');
  }
}

theme.InstagramSection = new function(){
  this.onSectionLoad = function(target){
    $('.willstagram:not(.willstagram-placeholder)', target).each(function(){
      var user_id = $(this).data('user_id');
      var tag = $(this).data('tag');
      var access_token = $(this).data('access_token');
      var count = $(this).data('count') || 10;
      var $willstagram = $(this);
      var url = '';
      if(typeof user_id != 'undefined') {
        url = 'https://api.instagram.com/v1/users/' + user_id + '/media/recent?count='+count;
      } else if(typeof tag != 'undefined') {
        url = 'https://api.instagram.com/v1/tags/' + tag + '/media/recent?count='+count;
      }
      $.ajax({
        type: "GET",
        dataType: "jsonp",
        cache: false,
        url: url
        + (typeof access_token == 'undefined'? '' : ('&access_token='+access_token)),
        success: function(res) {
          if(typeof res.data != 'undefined') {
            var $itemContainer = $('<ul class="items">').appendTo($willstagram);
            var limit = Math.min(20, res.data.length);
            for(var i = 0; i < limit; i++) {
              var photo_url = res.data[i].images.standard_resolution.url.replace('http:', '');
              var link = res.data[i].link;
              var caption = res.data[i].caption != null ? res.data[i].caption.text : '';
              $itemContainer.append($('<li />').append('<div class="item"><a target="_blank" href="'+link+'"><img src="'+photo_url+'" /></a><div class="desc">'+caption+'</div></div>'));
            }
          } else if(typeof res.meta !== 'undefined' && typeof res.meta.error_message !== 'undefined') {
            $willstagram.append('<div class="willstagram__error">'+res.meta.error_message+'</div>');
          }
        }
      });
      if(typeof $(this).data('account') != 'undefined') {
        var splSel = $(this).data('account').split('|');
        var $account = $(this).closest(splSel[0]).find(splSel[1]);
        $.ajax({
          type: "GET",
          dataType: "jsonp",
          url: 'https://api.instagram.com/v1/users/self/?access_token='+access_token,
          success: function(res) {
            if(typeof res.data != 'undefined') {
              $('<a>').html('@'+res.data.username).attr({
                href: 'https://www.instagram.com/'+res.data.username,
                target: '_blank'
              }).appendTo($account);
            }
          }
        });
      }
    });
  }
}

theme.SlideshowSection = new function(){
  this.onSectionLoad = function(target){
    $('.slideshow', target).each(function(){
      $(this).slick({
        autoplay: $(this).hasClass('auto-play'),
        fade: $(this).data('slideshow-transition') == 'fade',
        infinite: true,
        useTransform: true,
        arrows: false,
        dots: true,
        prevArrow: '<button type="button" class="slick-prev">'+theme.icons.chevronLightLeft+'</button>',
        nextArrow: '<button type="button" class="slick-next">'+theme.icons.chevronLightRight+'</button>',
        lazyLoad: $(this).find('[data-lazy]').length > 0 ? 'ondemand' : null,
        autoplaySpeed: 17000, // milliseconds to wait between slides
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              fade: false
            }
          },
          {
            breakpoint: 768,
            settings: {
              fade: false,
              arrows: false,
              dots: true,
              lazyLoad: $(this).find('[data-lazy]').length > 0 ? 'progressive' : null
            }
          }
        ]
      });
    });

    $(window).trigger('slideshowfillheight');

    theme.checkViewportFillers();

    theme.assessAltLogo();
  }

  this.onSectionUnload = function(target){
    $('.slick-slider', target).slick('unslick');
  }

  this.onBlockSelect = function(target){
    $(target).closest('.slick-slider')
      .slick('slickGoTo', $(target).data('slick-index'))
      .slick('slickPause');
  }

  this.onBlockDeselect = function(target){
    $(target).closest('.slick-slider')
      .slick('slickPlay');
  }
}

theme.FeaturedBlogSection = new function(){
  this.onSectionLoad = function(target){
    $('.slideshow', target).each(function(){
      $(this).slick({
        autoplay: $(this).hasClass('auto-play'),
        fade: $(this).data('slideshow-transition') == 'fade',
        infinite: true,
        useTransform: true,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              fade: false
            }
          }
        ]
      });
    });

    $('.featured-blog__prev', target).on('click', function(){
      $(this).closest('.featured-blog').find('.slideshow').slick('slickPrev');
      return false;
    });

    $('.featured-blog__next', target).on('click', function(){
      $(this).closest('.featured-blog').find('.slideshow').slick('slickNext');
      return false;
    });

    $(window).trigger('slideshowfillheight');

    theme.checkViewportFillers();

    theme.assessAltLogo();
  }

  this.onSectionUnload = function(target){
    $('.slick-slider', target).slick('unslick');
    $('.featured-blog__prev, .featured-blog__next', target).off('click');
  }
}

theme.TextBesideImageSection = new function(){
  this.onSectionLoad = function(target){
    /// Ensure image-beside-text sections look right
    $('.text-beside-image').trigger('assessImageBesideText');
  }
}

theme.TextOverImageSection = new function(){
  var _ = this;
  _.checkTextOverImageHeights = function(){
    $('[data-section-type="text-over-image"], [data-nested-section-type="text-over-image"]').each(function(){
      var $imageContainer = $('.rimage-outer-wrapper', this);
      var imageHeight = $('.rimage-wrapper', this).outerHeight();
      var textVerticalPadding = parseInt($('.overlay', this).css('padding-top'));
      var textHeight = $('.overlay__content', this).height() + textVerticalPadding * 2;
      if(textHeight > imageHeight + 2) { // +2 for rounding errors
        $imageContainer.css('height', textHeight);
      } else {
        $imageContainer.css('height', '');
      }
    });
  }

  this.onSectionLoad = function(target){
    _.checkTextOverImageHeights();
    $(window).off('.textOverImageSection');
    $(window).on('load.textOverImageSection', _.checkTextOverImageHeights);
    $(window).on('resize.textOverImageSection', _.checkTextOverImageHeights);
    theme.checkViewportFillers();
  }

  this.onSectionUnload = function(target){
    $(window).off('.textOverImageSection');
  }
}

theme.MapSection = new function(){
  var _ = this;
  _.config = {
    zoom: 14,
    styles: {
      default: [],
      silver: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}],
      retro: [{"elementType":"geometry","stylers":[{"color":"#ebe3cd"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#523735"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f1e6"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#c9b2a6"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#dcd2be"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#ae9e90"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b9d3c2"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#92998d"}]}],
      dark: [{"elementType":"geometry","stylers":[{"color":"#212121"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#212121"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#757575"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#181818"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"poi.park","elementType":"labels.text.stroke","stylers":[{"color":"#1b1b1b"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#8a8a8a"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#373737"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#3c3c3c"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#4e4e4e"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#3d3d3d"}]}],
      night: [{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#17263c"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}],
      aubergine: [{"elementType":"geometry","stylers":[{"color":"#1d2c4d"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#8ec3b9"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#1a3646"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#64779e"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#334e87"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#023e58"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#283d6a"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6f9ba5"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#023e58"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#3C7680"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#304a7d"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#2c6675"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#255763"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#b0d5ce"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#023e58"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"transit.line","elementType":"geometry.fill","stylers":[{"color":"#283d6a"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#3a4762"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#0e1626"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#4e6d70"}]}]
    }
  };
  _.apiStatus = null;
  _.mapsToLoad = [];

  this.geolocate = function($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  this.createMap = function(container) {
    var $map = $('.map-section__map-container', container);

    return _.geolocate($map)
      .then(
        function(results) {
          var mapOptions = {
            zoom: _.config.zoom,
            styles: _.config.styles[_.style],
            center: results[0].geometry.location,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
            zoomControl: true
          };

          _.map = new google.maps.Map($map[0], mapOptions);
          _.center = _.map.getCenter();

          var marker = new google.maps.Marker({
            map: _.map,
            position: _.center
          });

          google.maps.event.addDomListener(window, 'resize', function() {
            google.maps.event.trigger(_.map, 'resize');
            _.map.setCenter(_.center);
          });
        }.bind(this)
      )
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = theme.strings.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = theme.strings.addressQueryLimit;
            break;
          default:
            errorMessage = theme.strings.addressError;
            break;
        }

        // Only show error in the theme editor
        if (Shopify.designMode) {
          var $mapContainer = $map.parents('.map-section');

          $mapContainer.addClass('page-width map-section--load-error');
          $mapContainer
            .find('.map-section__wrapper')
            .html(
              '<div class="errors text-center">' + errorMessage + '</div>'
            );
        }
      });
  }

  this.onSectionLoad = function(target){
    var $container = $(target);
    // Global function called by Google on auth errors
    window.gm_authFailure = function() {
      if (!Shopify.designMode) return;

      theme.$container.addClass('page-width map-section--load-error');
      theme.$container
        .find('.map-section__wrapper')
        .html(
          '<div class="errors text-center">' + theme.strings.authError + '</div>'
        );
    }

    // create maps
    var key = $container.data('api-key');
    _.style = $container.data('map-style');

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (_.apiStatus === 'loaded') {
      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + key
        ).then(function() {
          _.apiStatus = 'loaded';
          _.createMap($container);
        });
      } else {
        _.createMap($container);
      }
    } else {
      _.mapsToLoad.push($container);

      if (_.apiStatus !== 'loading') {
        _.apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function() {
            _.apiStatus = 'loaded';
            // API has loaded, load all Map instances in queue
            $.each(_.mapsToLoad, function(index, mapContainer) {
              _.createMap(mapContainer);
            });
          });
        }
      }
    }
  }

  this.onSectionUnload = function(target){
    if (typeof window.google !== 'undefined') {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  }
}

theme.ProductTemplateSection = new function(){
  this.onSectionLoad = function(target){
    // header assessment first (affects gallery height)
    theme.checkViewportFillers();
    theme.assessAltLogo();

    /// Product page upper gallery
    $('.theme-gallery', target).each(function(){
      var $gallery = $(this);
      var $swiperCont = $gallery.find('.swiper-container');

      //Forcefully set container & image heights to fix plugin
      $(window).on('doThemeGalleryResizeCheck.productTemplateGallery resize.productTemplateGallery', function(){
        var galleryHeight = 400;

        if($(window).width() > 767) {
          galleryHeight = $(window).height() - $('.product-detail .product-detail__container').outerHeight();
          //galleryHeight = $(window).height() - $('.product-detail .product-detail__container').outerHeight() - $swiperCont.offset().top;
        }

        $swiperCont.height(galleryHeight);
        // set image dimensions (and reveal them)
        $swiperCont.find('img').each(function(){
          $(this).height(galleryHeight);
          $(this).width(galleryHeight * $(this).data('aspectratio'));
        });
      }).trigger('doThemeGalleryResizeCheck');

      // indicate if header over the gallery
      $(window).on('load.productTemplateGallery scroll.productTemplateGallery', function(){
        $('body').toggleClass('header-over-gallery', $(window).scrollTop() < $gallery.height() - $('#site-control').outerHeight());
      });

      var swiperOpts = {
        mode: 'horizontal',
        loop: false,
        slidesPerView: 'auto',
        resizeReInit: true,
        centeredSlides: $gallery.find('img').length == 1,
        autoHeight: false,
        freeMode: true,
        freeModeFluid: true,
        scrollContainer: true,
        grabCursor: true,
        createPagination: false
      };
      if($('.swiper-scrollbar').length) {
        $.extend(swiperOpts, {
          scrollbar: '.swiper-scrollbar',
          scrollbarDraggable : false,
          scrollbarHide: false,
          scrollbarSnapOnRelease: true
        });
      }

      var startIndex = $gallery.find('.current-img').index();

      var swiper = $swiperCont.swiper(swiperOpts);

      if(startIndex > 0) {
        swiper.slideTo(startIndex, 0);
      }

      $('.theme-gallery-thumb', target).on('click', 'a', function(){
        swiper.slideTo($(this).parent().index(), 1000);
        return false;
      });
    });

    /// Carousels
    $('.carousel-wrapper .carousel:not(.slick-initialized)', target).each(function(){
      $(this).on('init reInit setPosition', function(){
        var lastSlide = $(this).find('.slick-slide:last');
        if(lastSlide.length > 0) {
          var slideInnerWidth = lastSlide.position().left + lastSlide.outerWidth(true);
          var $carouselWrapper = $(this).parent();
          var carouselWidth = $carouselWrapper.outerWidth(true);

          $carouselWrapper.css('margin-left', Math.max(0, carouselWidth - slideInnerWidth));
          $(this).find('.slick-next, .slick-prev').toggleClass('theme-unnecessary', carouselWidth > slideInnerWidth);
        }
      }).slick({
        autoplay: false,
        fade: false,
        infinite: false,
        useTransform: true,
        arrows: true,
        dots: false,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
        prevArrow: '<button type="button" class="slick-prev">'+theme.icons.chevronLeft+'</button>',
        nextArrow: '<button type="button" class="slick-next">'+theme.icons.chevronRight+'</button>'
      });
    });

    /// Product options
    theme.OptionManager.initProductOptions($('select[name="id"]', target));

    /// Boxed-options
    $('.selector-wrapper select[data-make-box]').each(function(){
      $(this).find('option[value=""]').remove(); //Remove 'Pick a' option, if exists
    }).clickyBoxes().parent().addClass('has-clickyboxes');

    /// Visual style of dropdowns
    $('select:not(.original-selector)').selectReplace().closest('.selector-wrapper').addClass('has-pretty-select');

    /// Size chart
    $('.size-chart-link', target).on('click', function(){
      $.colorbox({
        inline: true,
        href: '#size-chart-content > .size-chart'
      });
      return false;
    });

    /// Product fill areas
    $('[data-fill-with-product]', target).fillWithShopifyProduct();

    // Related product layout
    $('.jiggly-split', target).trigger('columnflow');

    var _ = this;

    $(target).one('reinit', function() {
      _.onSectionUnload(target);
      _.onSectionLoad(target);
    });

  }

  this.onSectionUnload = function(target){
    $(window).off('.productTemplateGallery');
    $('.theme-gallery-thumb', target).off('click');
    $('.carousel-wrapper .carousel', target).off('init reInit setPosition');
    $('.slick-slider', target).slick('unslick');
    $('.size-chart-link', target).off('click');
    theme.OptionManager.unloadProductOptions($('select[name="id"]', target));
  }
}

theme.CollectionTemplateSection = new function(){
  this.onSectionLoad = function(target){
    // Product layout
    $('.jiggly-split', target).trigger('columnflow');

    // Infinite scroll
    theme.loadInfiniteScroll(target);

    // Sorting
    var $sortBy = $('#sort-by', target);
    if($sortBy.length > 0) {
      queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      $sortBy.val($sortBy.data('initval')).trigger('change').on('change', function() {
        queryParams.sort_by = $(this).val();
        location.search = $.param(queryParams);
      });
    }

    // Visual style of dropdowns
    $('select').selectReplace();
  }
  this.onSectionUnload = function(target) {
    $('#sort-by', target).off('change');
    theme.unloadInfiniteScroll();
  }
}

theme.ListCollectionsSection = new function(){
  this.onSectionLoad = function(target){
    $('.jiggly-split', target).trigger('columnflow');
  }
}

theme.SearchTemplateSection = new function(){
  this.onSectionLoad = function(target){
    $('.jiggly-split', target).trigger('columnflow');

    theme.loadInfiniteScroll(target);
  }
  this.onSectionUnload = function(target) {
    theme.unloadInfiniteScroll();
  }
}

theme.BlogTemplateSection = new function(){
  this.onSectionLoad = function(target){
    /// Visual style of dropdowns
    $('select').selectReplace();

    theme.allowRTEFullWidthImages(target);
  }
}

theme.ArticleTemplateSection = new function(){
  this.onSectionLoad = function(target){
    theme.allowRTEFullWidthImages(target);
  }
}

theme.CartTemplateSection = new function(){
  this.onSectionLoad = function(target){
    // terms and conditions checkbox
    if($('#cartform input#terms', target).length > 0) {
      $(document).on('click.cartTemplateSection', '#cartform [name="checkout"]:submit, .additional-checkout-buttons :submit, .additional-checkout-buttons input[type=image], a[href="/checkout"]', function() {
        if($('#cartform input#terms:checked').length == 0) {
          alert("You must agree to the terms and conditions before continuing.");
          return false;
        }
      });
    }
  }

  this.onSectionUnload = function(target){
    $(document).off('.cartTemplateSection');
  }
}

// A section that contains other sections, e.g. story page
theme.NestedSectionsSection = new function(){
  this.onSectionLoad = function(container){
    // load child sections
    $('[data-nested-section-type]', container).each(function(){
      var type = $(this).attr('data-nested-section-type');
      var section = null;
      for(var i=0; i<theme.Sections._sections.length; i++) {
        if(theme.Sections._sections[i].type == type) {
          section = theme.Sections._sections[i].section;
        }
      }
      if(section) {
        theme.Sections._instances.push({
          target: this,
          section: section
        });
        section.onSectionLoad(this);
      }
    });
    theme.checkViewportFillers();
    theme.assessAltLogo();
  }

  this.onSectionUnload = function(container){
    // unload child sections
    $('[data-nested-section-type]', container).each(function(){
      theme.Sections.sectionUnload(this);
    });
  }

  this.onBlockSelect = function(target){
    // scroll to block
    $(window).scrollTop($(target).offset().top - 100);
  }
}

theme.FeaturedCollectionsSection = new function(){
  this.onSectionLoad = function(target){
    $('.jiggly-split', target).trigger('columnflow');
  }
}

theme.FeaturedProductsSection = new function(){
  this.onSectionLoad = function(target){
    $('.jiggly-split', target).trigger('columnflow');
  }
}

theme.FeaturedProductSection = new function(){
  this.onSectionLoad = function(target){
    // Swiping gallery
    var $gallery = $('.theme-gallery', target);

    if($gallery.length) {
      // For all of these galleries - forcefully set image sizes to fix plugin
      $(window).off('.featuredProductGallery');
      $(window).on('doThemeGalleryResizeCheck.featuredProductGallery resize.featuredProductGallery', function(){
        $('.featured-product--with-gallery .theme-gallery').each(function(){
          // set image dimensions (and reveal them)
          var galleryHeight = $(this).height();
          $(this).find('.swiper-container').height(galleryHeight);
          $(this).find('img').each(function(){
            $(this).height(galleryHeight);
            $(this).width(galleryHeight * $(this).data('aspectratio'));
          });
        });
      }).trigger('doThemeGalleryResizeCheck');

      var swiperOpts = {
        mode: 'horizontal',
        loop: false,
        slidesPerView: 'auto',
        resizeReInit: true,
        centeredSlides: false,
        autoHeight: false,
        freeMode: true,
        freeModeFluid: true,
        scrollContainer: true,
        grabCursor: true,
        createPagination: false
      };
      if($('.swiper-scrollbar', target).length) {
        var sectionClass = '';
        var classes = $(target).closest('.featured-product')[0].className.split(/\s+/);
        for(var i=0; i<classes.length; i++) {
          if(classes[i].indexOf('section-id-') > -1) {
            sectionClass = '.' + classes[i];
          }
        }
        $.extend(swiperOpts, {
          scrollbar: sectionClass + ' .swiper-scrollbar',
          scrollbarDraggable : false,
          scrollbarHide: false,
          scrollbarSnapOnRelease: true
        });
      }

      var startIndex = $gallery.find('.current-img').index();
      var swiper = $gallery.find('.swiper-container').swiper(swiperOpts);
      if(startIndex > 0) {
        swiper.slideTo(startIndex, 0);
      }
    }

    /// Product options
    theme.OptionManager.initProductOptions($('select[name="id"]', target));

    /// Boxed-options
    $('.selector-wrapper select[data-make-box]', target).each(function(){
      $(this).find('option[value=""]').remove(); //Remove 'Pick a' option, if exists
    }).clickyBoxes().parent().addClass('has-clickyboxes');

    /// Visual style of dropdowns
    $('select:not(.original-selector)', target).selectReplace().closest('.selector-wrapper').addClass('has-pretty-select');
  }

  this.onSectionUnload = function(target){
    if($('.featured-product--with-gallery .theme-gallery').length == 0) {
      $(window).off('.featuredProductGallery');
    }
    theme.OptionManager.unloadProductOptions($('select[name="id"]', target));
  }
}

theme.allowRTEFullWidthImages = function(container) {
  $('.rte--allow-full-width-images p > img, .rte--allow-full-width-images div > img', container).each(function(){
    if($(this).siblings().length == 0) {
      $(this).unwrap().wrap('<div class="no-side-pad">');
    }
  });
  $('.rte--allow-full-width-images p > a > img, .rte--allow-full-width-images div > a > img', container).each(function(){
    if($(this).siblings().length == 0 && $(this).parent().siblings().length == 0) {
      $(this).parent().unwrap().wrap('<div class="no-side-pad">');
    }
  });
}

theme.loadInfiniteScroll = function(container){
  /// Pagination-replacement
  $('.pagination.infiniscroll:not(.infinit)', container).addClass('infinit').each(function(){
    var waitForTrigger = $(this).hasClass('wait-for-trigger');
    var $pager = $('<div class="pager-button"><a href="#">'+theme.icons.chevronDown+'</a></div>');
    $(this).replaceWith($pager);
    $pager.find('a').attr('href', $(this).find('.next a').attr('href'));

    $pager.on('click', 'a', function(e){
      if($(this).hasClass('loading')) {
        return false;
      }
      //Show spinner
      $(this).addClass('loading');
      //Load next page
      var $link = $(this);
      $.get($(this).attr('href'), function(data){
        var $data = $($.parseHTML(data));
        //Grab products & insert into page
        var indexOffset = $('.product-list .product-block').length;
        var $newProducts = $data.find('.product-list .product-block').hide().appendTo('.product-list').filter('.product-block').each(function(index){
          $(this).removeAttr('data-loop-index').data('loop-index', indexOffset + index);
        });

        //Sort by offset from the top
        //Fix height
        $('.product-list').height($('.product-list').height());

        //Prep entry transitions
        $newProducts.addClass('pre-trans').css('display', '');

        //Put everything in new column layout
        $('.jiggly-split').trigger('forcecolumnflow');

        //Find total height to slide to
        var newHeight = 0;
        $('.product-list').children().each(function(){
          var h = $(this).position().top + $(this).height();
          if(h > newHeight) newHeight = h;
        });

        //Slide down, reveal & prep for more
        $('.product-list').animate({ height: newHeight }, 500, function(){
          $(this).css('height', '');

          //At this point, we're ready to transition in & load more
          $newProducts.removeClass('pre-trans');

          //Spin no more
          var $next = $data.find('.pagination .next a');

          if($next.length == 0) {
            //We are out of products
            $pager.html('<span class="no-more">'+"No more results"+'</span>').fadeOut(5000);
          } else {
            //More to show
            $link.attr('href', $next.attr('href')).removeClass('loading');
          }
        });
      });
      return false;
    });
    if(!waitForTrigger) {
      //Infiniscroll
      $(window).on('scroll.infiniscroll', function(){
        if($(window).scrollTop() + $(window).height() > $pager.offset().top) {
          $pager.find('a').trigger('click');
        }
      });
    }
  });
}
theme.unloadInfiniteScroll = function(){
  $(window).off('.infiniscroll');
}

// Manage option dropdowns
theme.productData = {};
theme.OptionManager = new function(){
  var _ = this;

  _._getVariantOptionElement = function(variant, $container) {
    return $container.find('select[name="id"] option[value="' + variant.id + '"]');
  };

  _.selectors = {
    container: '.product-area',
    gallery: '.theme-gallery',
    priceArea: '.price-area',
    submitButton: 'input[type=submit], button[type=submit]',
    multiOption: '.option-selectors'
  };

  _.strings = {
    priceNonExistent: "Unavailable",
    priceSoldOut: '[PRICE] <span class="sold-out">'+"Sold out"+'</span>',
    buttonDefault: "Add to cart",
    buttonNoStock: "Sold out",
    buttonNoVariant: "Unavailable"
  };

  _._getString = function(key, variant){
    var string = _.strings[key];
    if(variant) {
      string = string.replace('[PRICE]', '<span class="theme-money">'+Shopify.formatMoney(variant.price, theme.money_format)+'</span>');
    }
    return string;
  }

  _.getProductData = function($form) {
    var productId = $form.data('product-id');
    var data = null;
    if(!theme.productData[productId]) {
      theme.productData[productId] = JSON.parse(document.getElementById('ProductJson-' + productId).innerHTML);
    }
    data = theme.productData[productId];
    if(!data) {
      console.log('Product data missing (id: '+$form.data('product-id')+')');
    }
    return data;
  }

  _.addVariantUrlToHistory = function(variant) {
    if(variant) {
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    }
  }

  _.updateSku = function(variant, $container){
    $container.find('.sku .sku__value').html( variant ? variant.sku : '' );
    $container.find('.sku').toggleClass('sku--no-sku', !variant || !variant.sku);
  }

  _.updateBarcode = function(variant, $container){
    $container.find('.barcode .barcode__value').html( variant ? variant.barcode : '' );
    $container.find('.barcode').toggleClass('barcode--no-barcode', !variant || !variant.barcode);
  }

  _.updateBackorder = function(variant, $container){
    var $backorder = $container.find('.backorder');
    if($backorder.length) {
      if (variant && variant.available) {
        if (variant.inventory_management && _._getVariantOptionElement(variant, $container).data('stock') == 'out') {
          var productData = _.getProductData($backorder.closest('form'));
          $backorder.find('.selected-variant').html(productData.title + (variant.title.indexOf('Default') >= 0 ? '' : ' - '+variant.title) );
          $backorder.show();
        } else {
          $backorder.hide();
        }
      } else {
        $backorder.hide();
      }
    }
  }

  _.updatePrice = function(variant, $container) {
    var $priceArea = $container.find(_.selectors.priceArea);
    $priceArea.removeClass('on-sale');

    if(variant && variant.available == true) {
      var $newPriceArea = $('<div>');
      if(variant.compare_at_price > variant.price) {
        $('<span class="was-price theme-money">').html(Shopify.formatMoney(variant.compare_at_price, theme.money_format)).appendTo($newPriceArea);
        $newPriceArea.append(' ');
        $priceArea.addClass('on-sale');
      }
      $('<span class="current-price theme-money">').html(Shopify.formatMoney(variant.price, theme.money_format)).appendTo($newPriceArea);
      $priceArea.html($newPriceArea.html());
    } else {
      if(variant) {
        $priceArea.html(_._getString('priceSoldOut', variant));
      } else {
        $priceArea.html(_._getString('priceNonExistent', variant));
      }
    }
  }

  _._updateButtonText = function($button, string, variant) {
    $button.each(function(){
      var newVal;
      newVal = _._getString('button' + string, variant);
      if(newVal !== false) {
        if($(this).is('input')) {
          $(this).val(newVal);
        } else {
          $(this).html(newVal);
        }
      }
    });
  }

  _.updateButtons = function(variant, $container) {
    var $button = $container.find(_.selectors.submitButton);

    if(variant && variant.available == true) {
      $button.removeAttr('disabled');
      _._updateButtonText($button, 'Default', variant);
    } else {
      $button.attr('disabled', 'disabled');
      if(variant) {
        _._updateButtonText($button, 'NoStock', variant);
      } else {
        _._updateButtonText($button, 'NoVariant', variant);
      }
    }
  }

  _.updateContainerStatusClasses = function(variant, $container) {
    $container.toggleClass('variant-status--unavailable', !variant.available);
    $container.toggleClass('variant-status--backorder', variant.available
      && variant.inventory_management
      && _._getVariantOptionElement(variant, $container).data('stock') == 'out');
  }

  _.initProductOptions = function(originalSelect) {
    $(originalSelect).not('.theme-init').addClass('theme-init').each(function(){
      var $originalSelect = $(this);
      var productData = _.getProductData($originalSelect.closest('form'));

      // change state for original dropdown
      $originalSelect.on('change.themeProductOptions firstrun.themeProductOptions', function(e, variant){
        if($(this).is('input[type=radio]:not(:checked)')) {
          return; // handle radios - only update for checked
        }
        var variant = variant;
        if(!variant && variant !== false) {
          for(var i=0; i<productData.variants.length; i++) {
            if(productData.variants[i].id == $(this).val()) {
              variant = productData.variants[i];
            }
          }
        }
        var $container = $(this).closest(_.selectors.container);

        // update price
        _.updatePrice(variant, $container);

        // update buttons
        _.updateButtons(variant, $container);

        // variant images
        if (variant && variant.featured_image) {
          $container.find(_.selectors.gallery).trigger('variantImageSelected', variant);
        }

        // extra details
        _.updateBarcode(variant, $container);
        _.updateSku(variant, $container);
        _.updateBackorder(variant, $container);
        _.updateContainerStatusClasses(variant, $container);

        // variant urls
        var $form = $(this).closest('form');
        if($form.data('enable-history-state') && e.type != 'firstrun') {
          _.addVariantUrlToHistory(variant);
        }

        // multi-currency
        if(typeof Currency != 'undefined' && typeof Currency.convertAll != 'undefined' && $('[name=currencies]').length) {
          Currency.convertAll(shopCurrency, $('[name=currencies]').first().val(), theme.money_container);
          $('.selected-currency').text(Currency.currentCurrency);
        }
      });

      // split-options wrapper
      $originalSelect.closest(_.selectors.container).find(_.selectors.multiOption).on('change.themeProductOptions', 'select', function(){
        var selectedOptions = [];
        $(this).closest(_.selectors.multiOption).find('select').each(function(){
          selectedOptions.push($(this).val());
        });
        // find variant
        var variant = false;
        for(var i=0; i<productData.variants.length; i++) {
          var v = productData.variants[i];
          var matchCount = 0;
          for(var j=0; j<selectedOptions.length; j++) {
            if(v.options[j] == selectedOptions[j]) {
              matchCount++;
            }
          }
          if(matchCount == selectedOptions.length) {
            variant = v;
            break;
          }
        }
        // trigger change
        if(variant) {
          $originalSelect.val(variant.id);
        }
        $originalSelect.trigger('change', variant);
                      StampedFn.loadBadges();
                             
      });

      // first-run
      $originalSelect.trigger('firstrun');
    });
  }

  _.unloadProductOptions = function(originalSelect) {
    $(originalSelect).each(function(){
      $(this).off('.themeProductOptions');
      $(this).closest(_.selectors.container).find(_.selectors.multiOption).off('.themeProductOptions');
    });
  }
};

theme.addControlPaddingToModal = function(){
  $('.theme-modal.reveal > .inner').css('padding-top', $('#site-control').outerHeight());
}

theme.browserHas3DTransforms = function() {
  var el = document.createElement('p'),
      has3d,
      transforms = {
        'webkitTransform':'-webkit-transform',
        'OTransform':'-o-transform',
        'msTransform':'-ms-transform',
        'MozTransform':'-moz-transform',
        'transform':'transform'
      };

  // Add it to the body to get the computed style.
  document.body.insertBefore(el, null);

  for (var t in transforms) {
    if (el.style[t] !== undefined) {
      el.style[t] = "translate3d(1px,1px,1px)";
      has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
    }
  }

  document.body.removeChild(el);

  return (has3d !== undefined && has3d.length > 0 && has3d !== "none");
}

if(theme.browserHas3DTransforms()) { $('html').addClass('supports-transforms'); }

jQuery(function($){

  /// Fill a template with a Shopify product
  $.fn.fillWithShopifyProduct = function(){
    return $(this).filter(':not(.filled-with-product)').addClass('filled-with-product').each(function(){
      //Which prod we gettin' & where we puttin' it?
      var handle = $(this).data('fill-with-product');
      var $replaceTarget = $(this).find('script[type="text/template"]');
      var template = $replaceTarget.html();
      //Fetch data!
      $.getJSON('/products/' + handle + '.json', function(data){
        var product = data.product;
        //Encoded
        var $tempEl = $('<div>');
        for(var key in product) {
          var encoded = $tempEl.html(product[key]).text().replace(/"/g, '&quot;').replace(/'/g, '&rsquo;');
          template = template.replace(new RegExp('\\[encode:' + key + '\\]', 'ig'), encoded);
        }
        //Simple vals
        for(var key in product) {
          template = template.replace(new RegExp('\\[' + key + '\\]', 'ig'), product[key]);
        }
        //Images, e.g. "[img:compact]"
        var lastDot = product.image.src.lastIndexOf('.');
        template = template.replace(/\[img:([0-9a-z]*)\]/ig, product.image.src.slice(0, lastDot) + '_$1' + product.image.src.slice(lastDot));
        //Actual insertion
        $replaceTarget.replaceWith(template);
      });
    });
  };

  /// Gallery variant images
  $(document).on('variantImageSelected', '.theme-gallery', function(e, data){
    var variantSrc = data.featured_image.src.split('?')[0].replace(/http[s]?:/, '');
    var $swiper = $(this).closest('.product-area').find('.swiper-container');
    var $img = $swiper.find('[data-full-size^="'+variantSrc+'"]');
    if($img.length) {
      $swiper.data('swiper').slideTo($img.index(), 1000);
    }
  });

  /// Product columns
  $(document).on('columnflow', '.jiggly-split:not(rows-)', function(){
    var $oldCols = $(this).children('.column');
    var $products = $(this).find('.product-block').sort(function(a,b){ return $(a).data('loop-index') - $(b).data('loop-index') });

    var numNewCols = 0;
    if($(this).hasClass('dynamic-col-2')) numNewCols = 2;
    if($(this).hasClass('dynamic-col-3')) numNewCols = 3;
    if($(this).hasClass('dynamic-col-4')) numNewCols = 4;

    //Override with media query CSS
    if($(this).css('min-height') == '1px') {
      numNewCols = 0;
    }

    if(numNewCols != $(this).data('prevColCount')) {
      if(numNewCols == 0) {
        $(this).append($products);
      } else {
        //Create each column
        var newCols = [];
        for(var i=0; i<numNewCols; i++) {
          var widthClass;
          if(numNewCols == 2) widthClass = 'half';
          if(numNewCols == 3) widthClass = 'third';
          if(numNewCols == 4) widthClass = 'quarter';
          newCols.push( $('<div class="column"/>').addClass(widthClass).addClass('col-' + (i+1)).appendTo(this) );
        }
        //Fill them up based on height of each col
        $products.each(function(){
          //Get shortest
          var $shortestCol = $(newCols[0]);
          var shortestHeight = $shortestCol.height();
          var it = 0;
          for(var j=1; j<newCols.length; j++) {
            it = j;
            var thisHeight = $(newCols[j]).height();
            if(thisHeight < shortestHeight) {
              $shortestCol = $(newCols[j]);
              shortestHeight = thisHeight;
            }
          }
          $shortestCol.append(this);
        });
      }

      $oldCols.remove();
      $(this).data('prevColCount', numNewCols);
    }
  }).on('forcecolumnflow', '.jiggly-split:not(rows-)', function(){
    $(this).removeData('prevColCount').trigger('columnflow');
  });
  $('.jiggly-split').trigger('columnflow');
  $(window).on('debouncedresize', function(){
    $('.jiggly-split').trigger('columnflow');
  });

  /// Visual style of dropdowns
  $('select:not(.original-selector)').selectReplace().closest('.selector-wrapper').addClass('has-pretty-select');

  /// General-purpose lightbox
  $('a[rel=lightbox]').colorbox();

  /// Galleries (only on large screens)
  if($(window).width() >= 768) {
    $('a[rel="gallery"]').colorbox({rel:'gallery'});
  }

  /// Translations for colorbox
  $.extend($.colorbox.settings, {
    previous: "Previous",
    next: "Next",
    close: "Close"
  });

  /// Image-links
  $('.rte a img').closest('a').addClass('contains-img');

  /// Check if using correct logo (would be nice to assess on section move/load/unload as well)
  theme.assessAltLogo();

  /// On any section reload
  $(document).on('shopify:section:load', function(e){

    /// Image-links inside any rte block
    $('.rte a img', e.target).closest('a').addClass('contains-img');

    /// Feature-sized headers have a little fluff
    if($('.feature-header', e.target).length) {
      $(window).trigger('assessFeatureHeaders');
    }

  }); // end of shopify:section:load

  /// Slideshow fills viewport
  theme.lastViewportWidth = 0;
  $(window).on('load debouncedresize slideshowfillheight', function(e){
    // if only height changed, don't do anything, to avoid issue with viewport-size-change on mobile-scroll
    if(e.type == 'debouncedresize' && theme.lastViewportWidth == $(window).width()) {
      return;
    }

    // set height of slideshows
    var desiredHeight = $(window).height();
    var $announcement = $('.site-control .announcement:first');
    if($announcement.length) {
      desiredHeight -= $announcement.outerHeight();
    }
    $('.slideshow.fill-viewport, .slideshow.fill-viewport .slide').css('min-height', desiredHeight);

    // check for content that must be contained
    $('.slideshow.fill-viewport').each(function(){
      var inner = 0;
      $(this).find('.slide').each(function(){
        var t = 0;
        $('.fill-viewport__contain', this).each(function(){
          t += $(this).outerHeight(true);
        });
        if(inner < t) {
          inner = t;
        }
      });
      if(inner > desiredHeight) {
        $(this).css('min-height', inner);
        $('.slide', this).css('min-height', inner);
      }
    });

    theme.lastViewportWidth = $(window).width();

    // bump down any header-overlap areas to cater for announcements
    if($('body.header-section-overlap').length && $announcement.length) {
      $('#page-content').css('margin-top', $announcement.outerHeight());
    } else {
      $('#page-content').css('margin-top', '');
    }
  }).trigger('slideshowfillheight');


  /// Some states are dependent on scroll position
  $(window).on('scroll load assessFeatureHeaders', function(){
    var scrollTop = $(window).scrollTop();
    var appearenceBuffer = 60;
    var windowBottom = scrollTop + $(window).height() - appearenceBuffer;

    $('body').toggleClass('scrolled-down', scrollTop > 0);

    theme.assessAltLogo();

    $('.feature-header:not(.feature-header--visible)').filter(function(){
      var offset = $(this).offset().top;
      var height = $(this).outerHeight();
      return offset + height >= scrollTop && offset <= windowBottom;
    }).addClass('feature-header--visible');
  });

  /// Nav
  $('#page-menu .main-nav li:has(ul)').addClass('has-children');
  $('#page-menu.nav-uses-modal .main-nav li.has-children > a').append('<span class="arr">'+theme.icons.rarr+'</span>');

  //Drill down
  var drilldownTransSpeed = 250;
  $(document).on('click', '#page-menu.nav-uses-modal .main-nav li.has-children > a', function(){
    //Create new content
    var trimmedTitle = $(this).text().replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    //- Links
    var $content = $('<div class="container growth-area"/>').append( $(this).siblings('ul').clone().wrap('<div class="main-nav growth-area"/>').parent() );
    //- Title, in its own menu row, using subnav style for the other links
    $content.find('.main-nav > ul').wrap('<li/>').parent().wrap('<ul/>').parent().prepend('<li class="title">'+trimmedTitle+'</li>');
    //- Breadcrumbs
    //Current crumbs...
    var $crumbs = $(this).closest('.container').find('.crumbs').clone();
    //New crumbs
    if($crumbs.length == 0) {
      $crumbs = $('<ul class="crumbs"><li><a href="#">' + "Home" + '</a></li></ul>');
    }
    $crumbs.append('<li><a href="#">'+trimmedTitle+'</a></li>');
    $content.prepend($crumbs);

    //Hide current & show new
    var $containers = $('#page-menu > .inner > .container:not(.inactive)');
    $containers.addClass('inactive').fadeOut(drilldownTransSpeed, function(){
      $content.hide().insertAfter($containers.last()).fadeIn(drilldownTransSpeed);
      $content.closest('.theme-modal').focus(); // add focus for keyboard scrolling
    });
    return false;
  });
  //Drill back up
  $(document).on('click', '#page-menu.nav-uses-modal a[data-revert-back]', function(){
    $('#page-menu.nav-uses-modal > .inner > .container:not(.inactive)').fadeOutAndRemove(drilldownTransSpeed, function(){
      $('#page-menu.nav-uses-modal > .inner > .container.inactive:last').removeClass('inactive').fadeIn(drilldownTransSpeed);
    });
    return false;
  });
  //Oh, crumbs
  $(document).on('click', '#page-menu.nav-uses-modal .crumbs a', function(){
    var desiredNumContainers = $(this).parent().index() + 1;
    var $containers = $('#page-menu.nav-uses-modal > .inner > .container');
    if(desiredNumContainers < $containers.length) {
      $containers.slice(desiredNumContainers).fadeOutAndRemove(drilldownTransSpeed, function(){
        $('#page-menu.nav-uses-modal > .inner > .container.inactive:last').removeClass('inactive').fadeIn(drilldownTransSpeed);
      });
    }
    return false;
  });
  //Close and reset nav
  $(document).on('reset-modal', '#page-menu.nav-uses-modal', function(){
    closeThemeModal();
    setTimeout(function(){
      $('#page-menu.nav-uses-modal > .inner > .container').removeClass('inactive').show().slice(1).remove();
    }, 300); // Delay to match transition on .theme-modal.reveal
    return false;
  }).on('click', 'a[data-reset-and-close]', function(){
    $('#page-menu.nav-uses-modal').trigger('reset-modal');
    return false;
  });


  function isPageScrollin() {
    return $('#page-content').outerHeight() > $(window).height();
  }

  /// Modal windows
  var removeModalTimeoutID = -1;
  var closeModalDelay = 300;
  window.closeThemeModal = function(immediate){
    $('a[data-modal-toggle].active').removeClass('active');
    var $modal = $('.theme-modal.reveal').removeClass('reveal').addClass('unreveal');
    if($('html.supports-transforms').length && (typeof immediate == 'undefined' || !immediate)) {
      removeModalTimeoutID = setTimeout(function(){
        $('body').removeClass('modal-active');
        $('body, #page-content, #site-control').css('padding-right', '');
      }, closeModalDelay); // Delay to match transition on .theme-modal.reveal
    } else {
      $('body').removeClass('modal-active');
      $('body, #site-control').css('padding-right', '');
    }
    // tabindex
    $modal.find('a').attr('tabindex', '-1');
  };

  //Show arbitrary content in modal window
  window.showThemeModal = function(el){
    //Close current
    closeThemeModal(true);
    //Remove any existing temporary modals
    $('.theme-modal.temp').remove();
    //Actually add to the page
    var $el = $(el);
    $el.appendTo('body').addClass('reveal');
    theme.addControlPaddingToModal();
    //When body is under a modal & has scrollbar, it is not allowed to scroll,
    //so we overflow:hidden it and add a padding the same size as the scrollbar
    if(isPageScrollin()) {
      $('#page-content, #site-control').css('padding-right', $.scrollBarWidth());
    }
    //Set page state
    $('body').addClass('modal-active');
  };

  //Show existing modal container hidden on page
  window.showInPageModal = function($target){
    $target.removeClass('unreveal').addClass('reveal');
    theme.addControlPaddingToModal();
    var $inputs = $target.find('.focus-me').focus(); //Any inputs to highlight?
    $(this).addClass('active');
    //When body is under a modal, it is not allowed to scroll, so we need this to keep it the same width
    if(isPageScrollin()) {
      //$('body, #site-control').css('padding-right', $.scrollBarWidth());
    }
    $('body').addClass('modal-active');
    $('a[tabindex]', $target).removeAttr('tabindex');
    if($inputs.length == 0) {
      $target.closest('.theme-modal').focus(); // add focus for keyboard scrolling
    }
  };
  $(document).on('click', 'body:not(.modal-active) a[data-modal-toggle]', function(e){
    e.preventDefault();
    window.showInPageModal($($(this).data('modal-toggle')));
  });

  //Close modal on escape keypress
  $(document).on('keyup', function(e){
    if(e.which == 27) {
      closeThemeModal();
    }
  });
  //Close modal button
  $(document).on('click', 'body.modal-active a[data-modal-close]', function(){
    closeThemeModal();
    return false;
  });
  //Click outside container to close modal
  $(document).on('click', '.theme-modal', function(e){
    if(e.target == this) {
      closeThemeModal();

      //Trigger any reset events (e.g. in drilldown nav)
      $(this).trigger('reset-modal');
      return false;
    }
  });
  //Switch to a different modal
  $(document).on('click', 'body.modal-active a[data-modal-toggle]', function(){
    closeThemeModal(true);
    $(this).click();
    return false;
  });

  $(document).on('click', '.site-control a[data-modal-nav-toggle]', function(){
    if($('body.modal-active').length) {
      closeThemeModal();
      setTimeout(function(){
        $('#page-menu .crumbs a:first').trigger('click');
      }, 305); // after modal fade-out
    } else {
      window.showInPageModal($('#page-menu'));
    }
    return false;
  });


  //Open arbitrary page in a modal
  $(document).on('click', 'a[data-modal-target]', function(e){
    e.preventDefault();
    showThemeModal($('<div class="theme-modal temp" tabindex="-1"/>').append($('<div class="inner"/>').html($($(this).data('modal-target')).wrapInner('<div class="container"/>').html())));
  });

  //Show a quick generic text popup above an element
  window.showQuickPopup = function(message, $origin){
    var $popup = $('<div class="simple-popup"/>');
    var offs = $origin.offset();
    $popup.html(message).css({ 'left':offs.left, 'top':offs.top }).hide();
    $('body').append($popup);
    $popup.css('margin-top', - $popup.outerHeight() - 10);
    $popup.fadeIn(200).delay(3500).fadeOut(400, function(){
      $(this).remove();
    });
  };

  //Immmediately select contents when focussing on some inputs
  $(document).on('focusin click', 'input.select-on-focus', function(){
    $(this).select();
  }).on('mouseup', 'input.select-on-focus', function(e){
    e.preventDefault(); //Prevent mouseup killing select()
  });

  //Textareas increase size as you type
  $('#template textarea').each(function(){ $(this).autogrow({animate:false, onInitialize:true}) });


  //Ajax add-to-cart
  var shopifyAjaxAddURL = '/cart/add.js';
  var shopifyAjaxCartURL = '/cart.js';
  var shopifyAjaxStorePageURL = '/search';

  $(document).on('submit', 'form[action="/cart/add"]:not(.noAJAX, .feedback-go_to_cart)', function(e) {
    var $form = $(this);

    //Disable add button
    var $btn = $(this).find('[type=submit]').attr('disabled', 'disabled').addClass('confirmation');
    $btn.data('originalHtml', $btn.html()).html("Adding");

    //Add to cart
    $.post(shopifyAjaxAddURL, $form.serialize(), function(itemData) {
      //Enable add button
      $btn.html(theme.icons.tick + ' ' + "Added");
      setTimeout(function(){
        $btn.removeAttr('disabled').removeClass('confirmation').html($btn.data('originalHtml'));
      }, 4000);

      if($form.hasClass('feedback-add_in_modal')) {
        showThemeModal([
          '<div id="added-to-cart" class="theme-modal align-centre top-padded" tabindex="-1">',
          '<div class="inner">',
          '<div class="container">',
          '<h4>' + $. parseJSON(itemData).title + '</h4>',
          '<p>' + "was added to your cart" + '</p>',
          '<p class="content-row"><a class="circled-icon" href="/cart">'+theme.icons.tick+'</a></p>',
          '<p class="links"><a href="#" data-modal-close>'+"Continue shopping"+'</a> &bull; <a href="/cart">' + "Checkout" + '</a></p>',
          '</div>',
          '</div>',
          '</div>'
        ].join(''));
      }

      //Update header summary
      $.get(shopifyAjaxStorePageURL, function(data){
        var cartSummarySelector = '#site-control .cart';
        var $newCartObj = $($.parseHTML('<div>' + data + '</div>')).find(cartSummarySelector);
        var $currCart = $(cartSummarySelector);
        $currCart.replaceWith($newCartObj);
      });
    }, 'text').error(function(data) {
      //Enable add button
      $btn.removeAttr('disabled').removeClass('confirmation').html($btn.data('originalHtml'));

      //Not added, show message
      if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
        var jsonRes = $.parseJSON(data.responseText);
        window.showQuickPopup(jsonRes.description, $btn);
      } else {
        //Some unknown error? Disable ajax and submit the old-fashioned way.
        $form.addClass('noAJAX');
        $form.submit();
      }
    });
    return false;
  });

  $(document).on('click', '.quantity-wrapper [data-quantity]', function(){
    var adj = $(this).data('quantity') == 'up' ? 1 : -1;
    var $qty = $(this).closest('.quantity-wrapper').find('[name=quantity]');
    $qty.val( Math.max(1, parseInt($qty.val()) + adj) );
    return false;
  });

  /// Redirection dropdowns
  $(document).on('change', 'select.redirecter', function(){
    window.location = $(this).val();
  });

  /// Register all sections
  theme.Sections.init();
  theme.Sections.register('header', theme.HeaderSection);
  theme.Sections.register('slideshow', theme.SlideshowSection);
  theme.Sections.register('video', theme.VideoManager);
  theme.Sections.register('instagram', theme.InstagramSection);
  theme.Sections.register('map', theme.MapSection);
  theme.Sections.register('text-beside-image', theme.TextBesideImageSection);
  theme.Sections.register('text-over-image', theme.TextOverImageSection);
  theme.Sections.register('featured-products', theme.FeaturedProductsSection);
  theme.Sections.register('featured-product', theme.FeaturedProductSection);
  theme.Sections.register('featured-collections', theme.FeaturedCollectionsSection);
  theme.Sections.register('featured-blog', theme.FeaturedBlogSection);
  theme.Sections.register('product-template', theme.ProductTemplateSection);
  theme.Sections.register('collection-template', theme.CollectionTemplateSection);
  theme.Sections.register('search-template', theme.SearchTemplateSection);
  theme.Sections.register('blog-template', theme.BlogTemplateSection);
  theme.Sections.register('article-template', theme.ArticleTemplateSection);
  theme.Sections.register('list-collections', theme.ListCollectionsSection);
  theme.Sections.register('cart-template', theme.CartTemplateSection);
  theme.Sections.register('nested-sections', theme.NestedSectionsSection);
});

})(theme.jQuery);


(function($){
  window.theme = window.theme || {};

  theme.Global = function() {

    function Global() {
      this.settings = {
        set_offset_with_fixed_body: [
          '#site-control',
          '#admin_bar_iframe',
          '#preview-bar-iframe'
        ]
      };

      this.load();
    };

    Global.prototype = $.extend({}, Global.prototype, {
      load: function() {
        var ua = window.navigator.userAgent.toLowerCase(),
            current_bp,
            $scroll_example = $('.scroll-offset-example');

        window.ie = (/trident/gi).test(ua) || (/msie/gi).test(ua);
        window.edge = document.documentMode || /edge/.test(ua);
        window.ios = navigator.userAgent.match(/like Mac OS X/i);
        window.moz = typeof InstallTrigger !== 'undefined';
        window.$window = $(window);
        window.$html = $('html');
        window.$body = $html.find('body');

        if(ios) {
          $html.addClass('is-ios');
        } else if(edge) {
          $html.addClass('is-edge');
        } else if(ie) {
          $html.addClass('is-ie');
        } else if(moz) {
          $html.addClass('is-moz');
        }

        theme.rtl = $body.attr('dir') === 'rtl' ? true : false;

        theme.breakpoints = {
          values: {
            xs: 0,
            sm: 541,
            md: 778,
            lg: 1025,
            xl: 1260
          }
        };
        theme.breakpoints.main = theme.breakpoints.values.lg;
        theme.current = {};

        function checkWindow() {
          theme.current.width = window.innerWidth;
          theme.current.height = window.innerHeight;
        };

        function checkBreakpoint() {
          theme.current.is_mobile = theme.current.width < theme.breakpoints.main;
          theme.current.is_desktop = !theme.current.is_mobile;

          $.each(theme.breakpoints.values, function(k, v) {
            if(v > theme.current.width) {
              return false;
            }

            theme.current.bp = k;
          });

          if(current_bp && current_bp != theme.current.bp) {
            $(window).trigger('theme.changed.breakpoint');
          }

          current_bp = theme.current.bp;
        };

        function scrollPaddingStyle() {
          var $style = $('style.scroll-offset-style');

          theme.current.scroll_w = $scroll_example[0].offsetWidth - $scroll_example[0].clientWidth;

          if(theme.current.scroll_w > 0) {
            if(!$style.length) {
              var offset_scroll_style_html = 'body.offset-scroll-styles{padding-right:' + theme.current.scroll_w + 'px;}.fixed-elem.offset-scroll{padding-right:' + theme.current.scroll_w + 'px;}';

              $('head').append($('<style>').addClass('scroll-offset-style').html(offset_scroll_style_html));
            }
          } else {
            $style.remove();
          }
        };

        $(window).on('debouncedresize', function() {
          checkWindow();
          checkBreakpoint();

          $(window).trigger('theme.resize');
        });

        $(window).on('theme.changed.breakpoint', function() {
          scrollPaddingStyle();
        });

        checkWindow();
        checkBreakpoint();
        scrollPaddingStyle();

        $(window).on('load', function () {
          theme.is_loaded = true;
        });
      },
      bodyHasScroll: function(prop) {
        var d = document,
                e = d.documentElement,
                b = d.body,
                client = "client" + prop,
                scroll = "scroll" + prop;

        return /CSS/.test(d.compatMode) ? (e[client] < e[scroll]) : (b[client] < b[scroll]);
      },
      fixBody: function() {
        if (this.bodyHasScroll('Height')) {
          $body.addClass('offset-scroll');
          $.each(this.settings.set_offset_with_fixed_body, function(i, k) {
            $(k).addClass('offset-scroll fixed-elem');
          });
        }

        this._fixed_scroll_top = pageYOffset;

        $body.css({ top: pageYOffset * -1 });
        $body.addClass('offset-scroll-styles');
      },
      unfixBody: function() {
        $body.removeClass('offset-scroll offset-scroll-styles');

        $body.add($html).scrollTop(this._fixed_scroll_top);
        this._fixed_scroll_top = null;

        $body.css({ top: '' });

        $.each(this.settings.set_offset_with_fixed_body, function(i, k) {
          $(k).removeClass('fixed-elem offset-scroll');
        });
      },
      responsiveHandler: function(obj) {
        var namespace = obj.namespace ? obj.namespace : '.widthHandler',
                current_bp;

        function bind() {
          $.each(obj.events, function(event, func) {
            if(obj.delegate) {
              $(obj.element).on(event + namespace, obj.delegate, func);
            } else {
              $(obj.element).on(event + namespace, func);
            }
          });
        };

        function unbind() {
          $.each(obj.events, function(event) {
            $(obj.element).unbind(event + namespace);
          });
        };

        function on_resize() {
          if(theme.current.is_mobile !== current_bp) {
            current_bp = theme.current.is_mobile;

            if((obj.on_desktop && theme.current.is_desktop) || (obj.on_mobile && theme.current.is_mobile)) {
              bind();
            } else {
              unbind();
            }
          }
        };

        $(window).on('theme.resize' + namespace, function() {
          on_resize();
        });

        on_resize();

        return {
          unbind: function() {
            $(window).unbind('theme.resize' + namespace);
            unbind();
          }
        }
      },
    });

    theme.Global = new Global;
  };

  theme.Popups = function() {

    function Popups() {
      this.selectors = {
        popup: '.js-popup',
        button: '.js-popup-button',
        button_close: '[data-js-popup-close]',
        bg: '[data-js-popup-bg]'
      };

      this.load();
    };

    Popups.prototype = $.extend({}, Popups.prototype, {
      load: function() {
        if($(this.selectors.popup).length) {
          var _ = this;

          $body.on('click', this.selectors.button, function(e) {
            var $this = $(this),
                    name = $this.attr('data-js-popup-button');

            if(_.callByName(name, $this)) {
              e.preventDefault();
              return false;
            }
          });

          $body.on('click', this.selectors.button_close, function(e) {
            var $this = $(this),
                    name = $this.parents('[data-js-popup-name]').attr('data-js-popup-name');

            _.closeByName(name, $this);

            e.preventDefault();
            return false;
          });

          $body.on('click', this.selectors.popup + ' [data-js-popup-name]', function(e) {
            var $t = $(e.target);

            if($t[0].hasAttribute('data-js-popup-name')) {
              var name = $t.attr('data-js-popup-name');

              _.closeByName(name, $t);
            }
          });

          setTimeout(function() {
            $body.find(_.selectors.popup + ' [data-js-auto-call="true"]').each(function() {
              _.callByName($(this).attr('data-js-popup-name'));
            });
          }, 0);
        }
      },
      getByName: function(name) {
        var $popup = $(this.selectors.popup),
                $content = $popup.find('[data-js-popup-name="' + name + '"]');

        return $content;
      },
      callByName: function(name, $target) {
        var _ = this,
                $popup = $(this.selectors.popup),
                $bg = $(this.selectors.bg),
                $content = $popup.find('[data-js-popup-name="' + name + '"]'),
                is_ajax = $content.attr('data-js-popup-ajax') !== undefined ? true : false;

        if($content.length) {
          if(theme.current.is_desktop && $content[0].hasAttribute('data-js-popup-mobile-only')) {
            return false;
          }

          function onCall() {
            $popup.scrollTop(0);

            $bg.one('transitionend', function () {
              $content.add($bg).removeClass('animate');

              $content.trigger('call.after', [$content, $target ? $target : null]);
            });

            $content.add($bg).addClass('animate');

            setTimeout(function () {
              $content.add($bg).addClass('visible');

              if($bg.css('transition-duration') === '0s') {
                $bg.trigger('transitionend');
              }
            }, 0);

            if($content[0].hasAttribute('data-js-popup-mobile-only')) {
              $window.on('theme.changed.breakpoint.popups', function() {
                if(!theme.current.is_mobile) {
                  _.closeByName(name);
                }
              });
            }
          };

          $bg.unbind('transitionend');

          $content.trigger('call.before', [$content, $target ? $target : null]);

          $popup.addClass('active');

          $popup.find('[data-js-popup-name]').removeClass('show visible');
          $popup.add($content).addClass('show');

          theme.Global.fixBody();

          if(is_ajax) {
            $content.addClass('is-process-loading');

            /*theme.Loader.set($popup, {
              fixed: true,
              delay: true
            });*/

            $content.on('contentloaded', function () {
              $content.removeClass('is-process-loading');

              onCall();

              /*theme.Loader.unset($popup);*/
            });
          } else {
            onCall();
          }

          $body.on('keyup.popups', function(e) {
            if(e.keyCode === 27) {
              _.closeAll();
            }
          });

          $content.trigger('call.visible', [$content, $target ? $target : null]);

          return true;
        } else {
          return false;
        }
      },
      closeByName: function(name, $target) {
        var $popup = $(this.selectors.popup),
                $bg = $(this.selectors.bg),
                $content = $popup.find('[data-js-popup-name="' + name + '"]'),
                duration = $bg.css('transition-duration');

        if($content.length) {
          $content.unbind('contentloaded').removeClass('is-process-loading');
          $bg.unbind('transitionend');
          $body.unbind('keyup.popups');
          $window.unbind('theme.changed.breakpoint.popups');

          $content.trigger('close.before', [$content, $target ? $target : null]);

          /*theme.Loader.unset($popup);*/

          $bg.one('transitionend', function () {
            $popup.add($content).removeClass('show');
            $content.add($bg).removeClass('animate');

            theme.Global.unfixBody();

            $popup.removeClass('active');

            $content.trigger('close.after', [$content, $target ? $target : null]);
          });

          $content.add($bg).addClass('animate');

          if(!$bg.hasClass('visible') || $bg.css('transition-duration') === '0s') {
            $bg.trigger('transitionend');
          }

          $content.add($bg).removeClass('visible');

          return true;
        } else {
          return false;
        }
      },
      closeAll: function() {
        var _ = this,
                $popup = $(this.selectors.popup + '.active'),
                $content = $popup.find('[data-js-popup-name]').filter('.show, .is-process-loading');

        if($content.length) {
          $content.each(function () {
            _.closeByName($content.attr('data-js-popup-name'));
          });

          return true;
        } else {
          return false;
        }
      },
      addHandler: function(name, event, func) {
        $body.on(event, '[data-js-popup-name="' + name + '"]', function(e, $popup, $target) {
          func($popup, $target);
        });
      }
    });

    theme.Popups = new Popups;
  };

  theme.PopupCart = function() {

    function PopupCart() {
      this.settings = {
        popup_name: 'cart'
      };

      this.selectors = {
        cart: '.js-popup-cart-ajax'
      };

      this.load();
    };

    PopupCart.prototype = $.extend({}, PopupCart.prototype, {
      load: function() {
        var _ = this;

        theme.Popups.addHandler(this.settings.popup_name, 'call.visible', function($popup, $target) {
          _.update(function () {
            $popup.trigger('contentloaded');
          });
        });
      },
      _resultToHTML: function($items, data) {
        var $template = $($('#template-cart-ajax')[0].content),
            $fragment = $(document.createDocumentFragment());

        $.each(data.items, function(i) {
          var $product = $template.children().clone(),
              $image = $product.find('[data-js-popup-cart-image]'),
              $title = $product.find('[data-js-popup-cart-title]'),
              $variant = $product.find('[data-js-popup-cart-variant]'),
              $price = $product.find('[data-js-popup-cart-price]'),
              $quantity = $product.find('[data-js-popup-cart-quantity]'),
              $remove = $product.find('[data-js-popup-cart-remove]'),
              $links = $product.find('a').not('[data-js-popup-cart-remove]'),
              price = '';

          $product.attr('data-variant-id', this.variant_id);
          $links.attr('href', this.url);
          $title.html(this.product_title);
          $image.attr('src', Shopify.resizeImage(this.image, '360x')).attr('srcset', Shopify.resizeImage(this.image, '360x') + ' 1x, ' + Shopify.resizeImage(this.image, '360x@2x') + ' 2x');
          $quantity.val(this.quantity);
          $remove.attr('href', '/cart/change?line=' + (i + 1) + '&amp;quantity=0');

          if(this.variant !== 'Default variant') {
            $variant.html(this.variant_title).removeClass('d-none-important');
          }

          price += '<span>' + Shopify.formatMoney(this.price, window.money_format) + '</span>';

          if(this.compare_at_price && this.compare_at_price > this.price) {
            price += ' <span>' + Shopify.formatMoney(this.compare_at_price, window.money_format) + '</span>';

            $price.addClass('product-cart__price--sale');
          }

          $price.html(price);

          $fragment.append($product);
        });

        $items.html('');
        $items.append($fragment);
      },
      update: function(callback) {
        var _ = this;

        if (this.ajax) {
          this.ajax.abort();
        }

        this.ajax = $.getJSON("/cart.js", function (data) {
          var $cart = $(_.selectors.cart),
              $content = $cart.find('[data-js-popup-cart-content]'),
              $empty = $cart.find('[data-js-popup-cart-empty]'),
              $items = $cart.find('[data-js-popup-cart-items]'),
              $total = $cart.find('[data-js-popup-cart-total]');

          $content[data.item_count > 0 ? 'addClass' : 'removeClass']('show');
          $empty[data.item_count > 0 ? 'removeClass' : 'addClass']('show');

          if(data.item_count > 0) {
            $total.html(Shopify.formatMoney(data.total_price, window.money_format));

            _._resultToHTML($items, data);
          } else {
            $items.add($total).html('');
          }

          if(callback) {
            callback();
          }
        });
      }
    });

    theme.PopupCart = new PopupCart;
  };

  theme.Cart = function() {

    function Cart() {
      this.selectors = {
        button_remove: '[data-js-popup-cart-remove]',
        input_change: '[data-js-popup-cart-change]'
      };

      this.alerts = {
        alert_maximum_products_counts: "Added maximum number of products ({{ items }})"
      };

      this.load();
    };

    Cart.prototype = $.extend({}, Cart.prototype, {
      load: function() {
        var _ = this,
            timeout;

        $body.on('click', this.selectors.button_remove, function(e) {
          var $this = $(this),
              $product = $this.parents('[data-js-popup-cart-product]'),
              id = +$product.attr('data-variant-id');

          Shopify.removeItem(id, function(data) {
            _.updateHeaderCount(data);

            if(theme.Popups.getByName('cart').hasClass('visible')) {
              theme.PopupCart.update();
            }
          });

          e.preventDefault();
          return false;
        });

        function onChange() {
          var $this = $(this),
              $product = $this.parents('[data-js-popup-cart-product]'),
              id = +$product.attr('data-variant-id'),
              q = +$this.val();

          Shopify.changeItem(id, q, function(data) {
            _.updateHeaderCount(data);

            if(theme.Popups.getByName('cart').hasClass('visible')) {
              theme.PopupCart.update();
            }

            $.each(data.items, function() {
              if(this.id === id && q > this.quantity) {
                alert(_.alerts.alert_maximum_products_counts.replace('\{\{ items \}\}', this.quantity));
              }
            });
          });
        };

        $body.on('change', this.selectors.input_change, function() {
          var _ = this;

          clearTimeout(timeout);

          timeout = setTimeout(function() {
            onChange.call(_);
          }, 300);
        });

        $body.on('submit', 'form[action="/cart/add"]', function(e) {
          var $this = $(this),
              $button = $this.find('[name="add"]');

          function callback(data) {
            $button.removeClass('loading');

            theme.Popups.callByName('cart');
            _.updateHeaderCount(data);
          };

          $button.addClass('loading');

          var form_serialize_array = $this.serializeArray(),
              form_data_object = {};

          $.each(form_serialize_array, function() {
            form_data_object[this.name] = this.value;
          });

          Shopify.getCart(function(data) {
            var cart_has_product = false,
                quantity = +form_data_object.quantity || 1;

            $.each(data.items, function() {
              if(+this.variant_id === +form_data_object.id) {
                quantity += this.quantity;

                Shopify.changeItem(form_data_object.id, quantity, function(data) {
                  callback(data);
                });

                cart_has_product = true;

                return false;
              }
            });

            if(!cart_has_product) {
              Shopify.addItem(form_data_object.id, quantity, function(data) {
                callback(data);
              });
            }
          });

          e.preventDefault();
          return false;
        });
      },
      updateHeaderCount: function(data, callback) {
        function replace() {
          $('[data-js-cart-counter]').attr('data-js-cart-counter', data.item_count).html(data.item_count);

          if(callback && typeof callback === 'function') {
            callback(data);
          }
        };

        if(data && data.item_count !== undefined) {
          replace(data);
        } else {
          Shopify.getCart(function(data) {
            replace(data);
          });
        }
      }
    });

    theme.Cart = new Cart;
  };

  theme.InputNumber = function() {

    function InputNumber() {
      this.selectors = {
        elems: '.js-input-number',
        button: '[data-js-button]'
      };

      this.attrs = {
        method: 'data-js-button'
      };

      this.load();
    };

    InputNumber.prototype = $.extend({}, InputNumber.prototype, {
      load: function() {
        var _ = this;

        $body.on('click', this.selectors.elems + ' ' + this.selectors.button, function(e) {
          var $this = $(this),
              $input = $this.parents(_.selectors.elems).find('input'),
              method = $this.attr(_.attrs.method);

          $input[0][method]();
          $input.change();
        });
      }
    });

    theme.InputNumber = new InputNumber;
  };

  theme.AlignSwiper = function() {

    function AlignSwiper() {
      this.load();
    };

    AlignSwiper.prototype = $.extend({}, AlignSwiper.prototype, {
      load: function() {
        var $swiper = $('.theme-gallery').find('.swiper-container');

        if(!$swiper.length) {
          return;
        }

        var $swiper_wrapper = $swiper.find('.swiper-wrapper'),
            $slides = $swiper_wrapper.find('.swiper-slide'),
            $scrollbar = $('.swiper-scrollbar'),
            $scrollbar_drag = $scrollbar.find('.swiper-scrollbar-drag'),
            first_slide_w = $slides.first().width(),
            wind_w = $window.innerWidth(),
            set_margin = (first_slide_w - wind_w) / 2,
            range_stroke = $scrollbar.width() - $scrollbar_drag.width(),
            images_w = 0,
            slides_stroke,
            percentage_ratio;

        if(first_slide_w <= wind_w) {
          return;
        }

        $slides.each(function() {
          images_w += $(this).width();
        });

        slides_stroke = images_w - wind_w;
        percentage_ratio = set_margin * 100 / slides_stroke;

        $swiper_wrapper.css({
          'transform': 'translate3d(' + set_margin * -1 + 'px, 0px, 0px)'
        });

        $scrollbar_drag.css({
          'transform': 'translate3d(' + range_stroke / 100 * percentage_ratio + 'px, 0px, 0px)'
        });
      }
    });

    theme.AlignSwiper = new AlignSwiper;
  };

  theme.ProducGroup = function() {

    function ProducGroup() {
      this.load();
    };

    ProducGroup.prototype = $.extend({}, ProducGroup.prototype, {
      load: function() {
        $body.on('click', '.js-products-group a', function(e) {
          e.preventDefault();
          
          const size_select = document.querySelector('select#option-size');
          const choosed_size = size_select.options[size_select.selectedIndex].value;
          
          localStorage.choosed_size = choosed_size;

          var $this = $(this),
              href = $this.attr('href');

          var callback = function() {
            //$product_group_a = $product_group.find('a')
            //$product_group_a.removeClass('active');
            //$this.addClass('active');

            history.replaceState({foo: 'product'}, href, href);
          };

          $.ajax({
            type: 'GET',
            url: href,
            data: {
              view: 'no-layout'
            },
            cache: false,
            dataType: 'html',
            success: function (data) {
              var $replace_elems = $body.find('[data-js-product-group-replace]'),
                  $data = $('<div>').html(data),
                  $section = $body.find('[data-section-type="product-template"]');

              $replace_elems.each(function() {
                var $this = $(this),
                    replace_name = $this.attr('data-js-product-group-replace');

                $this.replaceWith($data.find('[data-js-product-group-replace="' + replace_name + '"]'));
              });

              $section.html($data.find('[data-section-type="product-template"]').html());

              $data.remove();
              $replace_elems.remove();

              $section.trigger('reinit');
              
              [...document.querySelectorAll('ul#clickyboxes-option-size li a')].forEach(item => {
    		    item.classList.remove("active");
			  })
              
              document.querySelector(`ul#clickyboxes-option-size li a[data-value="${choosed_size}"]`).click();
              localStorage.removeItem('choosed_size')

              theme.AlignSwiper.load();

              var $spr = $('[src*="productreviews.shopifycdn.com"]');

              $spr.replaceWith($('<script>').attr('src', $spr.attr('src'))).remove();

              callback();
              initSizeChart();
            }
          });

          return false;
        });
      }
    });

    theme.ProducGroup = new ProducGroup;
  };

  $(function() {
    theme.Global();
    theme.AlignSwiper();
    theme.Popups();
    theme.PopupCart();
    theme.Cart();
    theme.InputNumber();
    theme.ProducGroup();
  });
    
!function() {
    var e = document.querySelector(".logo");
    if (e) {
        var n, o, t = e.querySelector(".colorLogo"), a = e.querySelector(".colorLogo__canvas"), r = a.getContext("2d"), i = new Image;
        i.onload = function() {
            n = a.width = i.width + 100,
            o = a.height = i.height + 100,
            g("red", "#f81b84"),
            g("orange", "#f5ce28"),
            g("yellow", "#43c0f6"),
            g("green", "#a4d555"),
            g("blue", "#0000FF"),
            g("violet", "#8B00FF"),
            m()
        }
        ,
        i.src = "https://cdn.shopify.com/s/files/1/0061/7290/1440/files/Underair-logo-225px.png?839";
    
        var u = {}
          , l = !1
          , c = 0
          , h = [];
        !function() {
            for (var e = 0; e < 50; e++)
                h.push(null)
        }(),
        t.onmouseenter = function() {
            l = !0
        }
        ,
        t.onmouseleave = function() {
            l = !1
        }
        ;
        var f = ["red", "orange", "yellow", "green" ]
    }
    function g(e, t) {
        var n = document.createElement("canvas");
        n.width = i.width,
        n.height = i.height;
        var o = n.getContext("2d");
        o.drawImage(i, 0, 0),
        o.globalCompositeOperation = "source-in",
        o.fillStyle = t,
        o.fillRect(0, 0, i.width, i.height),
        u[e] = n
    }
    function m() {
        /*!function() {
            c++;
            var e = Math.floor(c / 6) % 4
              , t = l ? f[e] : null;
            h.pop(),
            h.pop(),
            h.pop(),
            h.pop(),
            h.unshift(t),
            h.unshift(t),
            h.unshift(t),
            h.unshift(t)
        }(),
        function() {
            r.clearRect(0, 0, n, o);
            for (var e = h.length - 1; 0 <= e; e--) {
                var t = h[e];
                t && r.drawImage(u[t], e + 1, e + 1)
            }
        }(),*/
        //requestAnimationFrame(m)
    }
}();

})(theme.jQuery);
  
function initSizeChart () {
	window.sizeChartsRelentless = window.sizeChartsRelentless || {};

	sizeChartsRelentless.backwardsCompatible = function (data) {
		var metafield = {};
		if (Array.isArray(data)) {
			metafield.charts = data;
		} else if (typeof data === 'object') {
			metafield = data;
		}
		var charts = metafield.charts;
		if (!charts) return metafield; // new shop

		// fix charts bug... don't know where it's coming from
		if (typeof metafield.charts === 'string') {
			delete metafield.charts;
			return metafield;
		}

		for (var i = 0; i < charts.length; i += 1) {
			var oldChart = charts[i].chart;
			if (oldChart) {
				charts[i].title = oldChart.title;
				charts[i].descriptionTop = oldChart.descriptionTop;
				charts[i].values = oldChart.values;
				charts[i].descriptionBottom = oldChart.descriptionBottom;
				charts[i].buttonPlacement = oldChart.buttonPlacement;
				if (charts[i].buttonPlacement) {
					if (charts[i].buttonPlacement === 'above-atc') { charts[i].buttonPlacement === 'above-add-to-cart'; }
					if (charts[i].buttonPlacement === 'below-atc') { charts[i].buttonPlacement === 'below-add-to-cart'; }
				}
				delete charts[i].chart;
			}

			if (!charts[i].conditions) charts[i].conditions = [];
			if (!charts[i].conditionsOperator) charts[i].conditionsOperator = 'products-matching-any-condition-below';

			var oldCollections = charts[i].collections;
			if (oldCollections) {
				for (var j = 0; j < oldCollections.length; j += 1) {
					charts[i].conditions.push({
						type: 'collection',
						operator: 'is equal to',
						id: oldCollections[j].id,
						title: oldCollections[j].title
					});
				}
				delete charts[i].collections;
			}

			var oldProducts = charts[i].products;
			if (oldProducts) {
				for (var j = 0; j < oldProducts.length; j += 1) {
					charts[i].conditions.push({
						type: 'product',
						operator: 'is equal to',
						id: oldProducts[j].id,
						title: oldProducts[j].title
					});
				}
				delete charts[i].products;
			}
		}
		return metafield;
	};

	if (!sizeChartsRelentless.product ||
	!sizeChartsRelentless.productCollections) {
		return;
	}

	// sizeChartsRelentless.charts           is the old array metafield
	// sizeChartsRelentless.metafield.charts is new
	var metafield = sizeChartsRelentless.charts || sizeChartsRelentless.metafield;
	if (!metafield) return;
	metafield = sizeChartsRelentless.backwardsCompatible(metafield);
	if (!metafield.charts) return;

	var sizeChartInstances = [];
	var frame = 0;
	var searching = true;
	var form, addToCart, addToCarts;
	var manualButtons;
	var $j;

	(function render() {
		if (frame === 60) {
			var script = document.createElement('SCRIPT');
			script.type = 'text/javascript';
			script.onload = function() {
				$j = window.jQuery.noConflict();
			};
			script.src = 'https://size-charts-relentless.herokuapp.com/js/jquery-3.3.1.min.js';
			document.getElementsByTagName('head')[0].appendChild(script);
		}
		if (window.$ || window.jQuery || $j) {
			$j = window.$ || window.jQuery || $j;

			// hide manual buttons
			manualButtons = $j('.scr-open-parent, .best-fit-size-chart');
			manualButtons.hide();

			var forms = $j('form[action*="/cart/add"]:not(.ssw-product-form):not(#add-item-qv)');
			forms.each(function (i, el) {
				$el = $j(el);
				if ($el.find('[name="id"]').length && $el.is(':visible') && !$el.closest('.globomenu-item').length) {
					form = $el;
					return false;
				}
			});

			if (!form) {
				form = forms.first();
			}

			addToCarts = form.find('[data-shopify="payment-button"].shopify-payment-button, [name="add"]:not(.product__sticky-button), .add-to-cart-btn, input#pre-order[type=submit], .add_to_cart, .add-to-cart, .addToCart, [type="submit"]:not(.product__sticky-button), .product-actions-row, button:not(.adjust-minus):not(.adjust-plus):not(.js-qty__adjust):not(.qty-minus):not(.qty-plus):not(.product__sticky-button), .tt-btn--cart');
			addToCarts.each(function () {
				addToCart = $j(this);
				if (addToCart.is(':visible')) {
					return false;
				}
			});

			if ((addToCart && addToCart.length) || manualButtons.length) {
				searching = false;

				setupProductPage();
				if (typeof sizeChartsRelentless.done === 'function') {
					sizeChartsRelentless.done(form, addToCart);
				}
			} else {
				sizeChartsRelentless.status = 'no addtocart button found';
			}
		}

		frame += 1;

		if (searching) {
			requestAnimationFrame(render);
		}
	}());

	function setupProductPage() {
		// REMOVED $j(function () {     }); FROM HERE
		sizeChartsRelentless.shadow = $j('<div class="scr-shadow"></div>');
		sizeChartsRelentless.modal = $j(
			'<div class="scr-modal">' +
				'<div class="scr-close"></div>' +
			'</div>'
		);
		$j('body').append(sizeChartsRelentless.shadow);
		$j('body').append(sizeChartsRelentless.modal);

		var foundMatch = matchSizeChart();

		if (foundMatch) {
			new SizeChart(foundMatch);
			sizeChartsRelentless.modal.find('.scr').remove();
			sizeChartsRelentless.modal.append(sizeChartInstances[0].element);
			var buttonPlacement = foundMatch.buttonPlacement && foundMatch.buttonPlacement !== 'use-global' ? foundMatch.buttonPlacement : metafield.buttonPlacement;
			addButton(buttonPlacement, metafield.buttonIcon, metafield.buttonText);
		} else {
			sizeChartsRelentless.status = 'no chart found';
		}

		$j('body').on('click', '', function (e) {
			var el = $j(e.target);
			if (el.closest('.scr-modal').length || el.hasClass('scr-open-size-chart')) return;
			closeModal();
		});

		$j('body').on('click', '.scr-close', closeModal);
		$j(window).keyup(function (e) {
			if (e.which === 27) closeModal();
		});

		$j('body').on('click', '.scr-open-size-chart', function () {
			sizeChartsRelentless.shadow.css({opacity: 1, visibility: 'visible'});
			sizeChartsRelentless.modal.css({opacity: 1, visibility: 'visible'});
		});
	}

	function matchSizeChart() {
		var cs = metafield.charts;
		for (var i = 0; i < cs.length; i += 1) {
			if (cs[i].conditionsOperator && cs[i].conditionsOperator === 'all-products') {
				return cs[i];
			} else if (cs[i].conditions && cs[i].conditions.length) {
				for (var j = 0; j < cs[i].conditions.length; j += 1) {
					switch (cs[i].conditions[j].type) {
						case 'collection':
							for (var k = 0; k < sizeChartsRelentless.productCollections.length; k += 1) {
								if (Number(cs[i].conditions[j].id) === sizeChartsRelentless.productCollections[k].id) {
									return cs[i];
								}
							}
						break;
						case 'product':
							if (Number(cs[i].conditions[j].id) === sizeChartsRelentless.product.id) {
								return cs[i];
							}
						break;
						case 'vendor':
							if (cs[i].conditions[j].title === sizeChartsRelentless.product.vendor) {
								return cs[i];
							}
						break;
					}
				}
			}
		}
		return false;
	}

	function SizeChart(data) {
		sizeChartInstances.push(this);
		this.style = 'basic';
		this.open = false;
		this.element = $j(
			'<div class="scr ' + this.style + '">' +
				'<h2>' + (data.values && data.title ? data.title : '') + '</h2>' +
				(data.descriptionTop ? '<div class="top-description">' + data.descriptionTop + '</div>': '') +
				'<table></table>' +
				(data.descriptionBottom ? '<div class="bottom-description">' + data.descriptionBottom + '</div>': '') +
			'</div>'
		);

		if (data.values && data.values[0] && data.values[0].length) {
			if (data.values[0].length !== 1 || data.values[0][0] !== '') {
				var values = data.values;
				for (var i = 0; i < values.length; i += 1) {
					this.element.find('table').append('<tr>');
					for (var j = 0; j < values[i].length; j += 1) {
						this.element.find('table tr:nth-child(' + (i + 1) + ')').append('<td>' + values[i][j] + '</td>');
					}
				}
			}
		}
	}

	function addButton(placement, icon, text) {
		icon = icon || 'ruler3';
		var el;

		// get el
		if (manualButtons.length) {
			el = manualButtons;
			el.show();
		} else {
			el = $j('<div class="best-fit-size-chart"></div>');
		}

		// add button
		el.each(function () {
			if ($j(this).find('button').length === 0) {
				$j(this).append('<!-- Best Fit - Size Charts by Relentless Apps -->\n<!-- https://apps.shopify.com/size-charts-by-relentless -->\n<button type="button" class="scr-open-size-chart ' + icon + '">' + (text ? text : 'Size Chart') + '</button>');
			}
		});

		// place auto button
		if (manualButtons.length === 0) {
			if (addToCart && addToCart.length) {
				addToCart.parent().css({flexWrap: 'wrap'});
				if (placement === 'above-add-to-cart') {
					return addToCart.before(el);
				} else if (placement === 'below-add-to-cart') {
					return addToCart.after(el);
				}
			}
			form.append(el);
		}
	}

	function closeModal() {
		sizeChartsRelentless.shadow.css({opacity: 0, visibility: 'hidden'});
		sizeChartsRelentless.modal.css({opacity: 0, visibility: 'hidden'});
	}
}